import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectBase } from './selectBase'

export const selectKbProduct = createSelector(
  selectBase,
  base => base.kb || emptyObj
)
